<vdr-page-block>
  <vdr-action-bar>
    <vdr-ab-left></vdr-ab-left>
    <vdr-ab-right>
      <vdr-action-bar-items locationId="banner-list"></vdr-action-bar-items>
      <a
        class="btn btn-primary"
        *vdrIfPermissions="['CreateBanner']"
        [routerLink]="['./', 'create']"
      >
        <clr-icon shape="plus"></clr-icon>
        Create a banner
      </a>
    </vdr-ab-right>
  </vdr-action-bar>
</vdr-page-block>
<vdr-data-table-2
  id="banner-list"
  [items]="items$ | async"
  [itemsPerPage]="itemsPerPage$ | async"
  [totalItems]="totalItems$ | async"
  [currentPage]="currentPage$ | async"
  [filters]="filters"
  (pageChange)="setPageNumber($event)"
  (itemsPerPageChange)="setItemsPerPage($event)"
>
  <vdr-bulk-action-menu
    locationId="banner-list"
    [hostComponent]="this"
    [selectionManager]="selectionManager"
  ></vdr-bulk-action-menu>
  <vdr-dt2-search
    [searchTermControl]="searchTermControl"
    searchTermPlaceholder="Filtre por slug"
  ></vdr-dt2-search>
  <vdr-dt2-column
    [heading]="'common.id' | translate"
    [sort]="sorts.get('id')"
    [hiddenByDefault]="true"
  >
    <ng-template let-banner="item">{{ banner.id }}</ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [sort]="sorts.get('slug')"
    [heading]="'common.slug' | translate"
  >
    <ng-template let-banner="item">
      <a
        class="button-ghost"
        [routerLink]="['./', banner.id]"
      >
        <span>{{ banner.slug }}</span>
        <clr-icon shape="arrow right"></clr-icon>
      </a>
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column [heading]="'common.created-at' | translate">
    <ng-template let-banner="item">
      {{ banner.createdAt | localeDate: 'short' }}
    </ng-template>
  </vdr-dt2-column>
</vdr-data-table-2>
